<template>
  <div class="dem-edi-ser-doc">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="documento" :class="(cpntSDocTp === 'NFSe' && [ '', null, undefined ].indexOf(cpntSDocAcoes[abasVal]) === -1 && cpntFinStatus !== 's') ? 'com-botao' : ''"  v-show='cpntDemStatus === "venda"'>
        <!-- SETA O CAMPO DOCUMENTO -->
        <App-Select :data-time="time" class="app-cpnt-field dem-edi-ser-doc--s_doc_tp"
          :cpntStatus='campos.s_doc_tp.status'
          :cpntId='campos.s_doc_tp.id'
          :cpntTabIndex='campos.s_doc_tp.tabIndex'
          :cpntNome='campos.s_doc_tp.nome'
          :cpntValue='campos.s_doc_tp.value'
          :cpntMensagem='campos.s_doc_tp.mensagem'
          :cpntMensagemTipo='campos.s_doc_tp.mensagemTipo'
          :cpntDisabled='cpntDemStatus !== "venda" || cpntFinStatus === "s" || cpntSDocNFEmitida === true || campos.s_doc_tp.disabled'
          :cpntMostrar='campos.s_doc_tp.mostrar'
          :cpntExplica='campos.s_doc_tp.explica'
          :cpntPlaceholder='campos.s_doc_tp.placeholder'
          :cpntValueRef='campos.s_doc_tp.valueRef'
          :cpntRouter='campos.s_doc_tp.router'
          :cpntField='campos.s_doc_tp.field'
          :cpntWhere='campos.s_doc_tp.where'
          :cpntAddButForm='campos.s_doc_tp.addButForm'
          :cpntKeyMostra='campos.s_doc_tp.keyMostra'
          :cpntTipoOrder='campos.s_doc_tp.tipoOrder'
          :cpntOrder='campos.s_doc_tp.order'
          :cpntOptions='campos.s_doc_tp.options'
          :cpntKeyValue='campos.s_doc_tp.keyValue'
          :cpntSearchMinimo='campos.s_doc_tp.searchMinimo'
          :cpntMask='campos.s_doc_tp.mask'
          :cpntOptionInicialNome='campos.s_doc_tp.optionInicialNome'
          :cpntOptionInicialValue='campos.s_doc_tp.optionInicialValue'

          :cpntOnChange='campos.s_doc_tp.onChange'
          :cpntOnBlur='campos.s_doc_tp.onBlur'
          :cpntOnKeyPressEnter='campos.s_doc_tp.onKeyPressEnter'
          ref="s_doc_tp"
        ></App-Select>
        
        <!-- VERIFICA SE DEVE MOSTRAR ALGUM BOTÃO NA TELA -->
        <template v-if="cpntSDocTp === 'NFSe' && [ '', null, undefined ].indexOf(cpntSDocAcoes[abasVal]) === -1">
          <!-- SETA O BOTÃO PARA MOSTRAR DETALHES -->
          <App-Button v-if="(cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].salvar === '1' || cpntSDocAcoes[abasVal].consultar === '1') === false" @onClick="() => { mostrarDetalhes = !mostrarDetalhes }">
            <template v-if="mostrarDetalhes === true">
              Ocultar Detalhes
            </template>
            <template v-else>
              Mostrar Detalhes
            </template>
          </App-Button>

          <!-- BOTÃO REINICIALIZAR -->
          <App-Button v-else-if="cpntSDocNFEmitida === false && cpntFinStatus !== 's'" @onClick="() => { demEdiSerDocReinicializarPreNotas() }" :cpntIcone="'historico'" :cpntExplica="{ mensagem: 'Clique aqui para reinicializar a(s) pré-notas. Todos os dados preenchidos abaixo serão perdidos e os valores reiniciados.', posicaoMy: 'top right', posicaoAt: 'bottom left' }"></App-Button>
        </template>
      </div>

      <template v-if='cpntSDocTp === "NFSe" && Object.keys(cpntSDocPreNotas).length === 0'>
        <div class="sem-pre-nota">
          <div>
            <App-Icone :cpntTipo='"alerta-amarelo"'></App-Icone>
          </div>
          Nenhum serviço inserido nesta venda.
          <br/>
          <br/>
          Insira ao menos um serviço para emitir a nota fiscal de serviço.
        </div>
      </template>

      <template v-else-if='cpntSDocTp !== "NFSe"'>
        <div class="campos">
          <Demanda-Editar-Servicos-Documento-Conteudo
          :cpntSDocTp="cpntSDocTp"
          :cpntDemandaId="cpntDemandaId"
          :cpntDemandaTotal="cpntDemandaTotal"

          :cpntSDocManualCodVerificacao="cpntSDocManualCodVerificacao"
          :cpntSDocManualDesconto="cpntSDocManualDesconto"
          :cpntSDocManualDataEmissao="cpntSDocManualDataEmissao"
          :cpntSDocManualNumero="cpntSDocManualNumero"
          :cpntSDocManualSerie="cpntSDocManualSerie"
          :cpntSDocManualRetencao="cpntSDocManualRetencao"
          ref='conteudo'
          ></Demanda-Editar-Servicos-Documento-Conteudo>
        </div>

        <div class="botoes">
          <!-- SETA O BOTÃO SALVAR E EMITIR -->
          <div class="iniciais">
            <!-- BOTÃO SALVAR -->
            <App-Button :cpntStatus="botoes.salvar" :cpntClass='[ "btn", "btn-default" ]' @onClick='() => { demEdiSerDocSalvarAlteracoes() }' :cpntTabIndex="17032060">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'salvar'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Salvar</span>
            </App-Button>
          </div>
        </div>
      </template>
      
      <!-- MOSTRA A TELA QUANDO TEM PRE-NOTA -->
      <template v-else>
        <div class="abas" v-if="Object.keys(abasVet).length >= 2">
          <RF-Aba
          :cpntAbas="Object.values(abasVet)"
          :cpntValue="abasVal"
          :cpntOnChange="demEdiSerDocOnChangeAba"
          ></RF-Aba>
        </div>

        <template v-if="[ '', null, undefined ].indexOf(abasVal) === -1">
          <div class="dem-edi-doc-df" v-if="[ '', null, undefined ].indexOf(cpntSDocPreNotas[abasVal].DocNumero) === -1">
            <div>
              <div>Ambiente: </div>
              <b v-html='cpntSDocPreNotas[abasVal].tpAmb === "2" ? "Homologação" : "Produção"'></b>
            </div>
            <div v-if="[ '', null, undefined, '0' ].indexOf(cpntSDocPreNotas[abasVal].DocAliasNum) !== -1">
              <div>RPS Número: </div>
              <b v-html='cpntSDocPreNotas[abasVal].s_doc_rps_n'></b>
            </div>
            <div v-else>
              <div>NFS-e Número: </div>
              <b v-html='cpntSDocPreNotas[abasVal].DocAliasNum'></b>
            </div>
            <div>
              <div>Série: </div>
              <span v-html='cpntSDocPreNotas[abasVal].DocSerie'></span>
            </div>
            <div>
              <div>Data/Hora Emissão: </div>
              <span v-html='cpntSDocPreNotas[abasVal].DocDhAut'></span>
            </div>
          </div>

          <div class="campos">
            <Demanda-Editar-Servicos-Documento-Conteudo v-if="[ '', null, undefined ].indexOf(cpntSDocPreNotas[abasVal]) === -1" :key="('sal--' + cpntSDocAcoes[abasVal].salvar) + ('emi--' + cpntSDocAcoes[abasVal].emitir) + ('ree--' + cpntSDocAcoes[abasVal].reemitir)"
            :cpntSDocTp="cpntSDocTp"
            :cpntDemandaId="cpntDemandaId"
            :cpntDemandaTotal="cpntDemandaTotal"
            :cpntSDocNFEmitida="!(cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].salvar === '1' || cpntSDocAcoes[abasVal].consultar === '1')"
            :cpntMostrarDetalhes="mostrarDetalhes === true || (cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].salvar === '1' || cpntSDocAcoes[abasVal].consultar === '1')"

            :cpntIdConPessoa="cpntIdConPessoa"
            :cpntSDocFlagSimplesPrestador="cpntSDocPreNotas[abasVal].s_flag_prestador_sn === '1'"
            :cpntSDocFlagSimplesTomador="cpntSDocPreNotas[abasVal].s_flag_tomador_sn === '1'"

            :cpntSDocNatOpe="{ id: cpntSDocPreNotas[abasVal].s_doc_nat_ope, nome: cpntSDocPreNotas[abasVal].s_doc_nat_ope_nome }"
            :cpntSDocRamoAtiv="{ cnae: cpntSDocPreNotas[abasVal].s_doc_ramo_id, nome: cpntSDocPreNotas[abasVal].s_doc_ramo_id_nome }"
            :cpntSDocAtividade="{ id: cpntSDocPreNotas[abasVal].s_doc_ati_id, nome: cpntSDocPreNotas[abasVal].s_doc_ati_id_nome }"
            :cpntSDocCodTrib="cpntSDocPreNotas[abasVal].s_doc_cod_tri"
            :cpntSDocMunicipioPrestacao="{ cod_ibge: cpntSDocPreNotas[abasVal].s_doc_mun_pre_ser, cidade: cpntSDocPreNotas[abasVal].s_doc_mun_pre_ser_cidade, uf: cpntSDocPreNotas[abasVal].s_doc_mun_pre_ser_uf }"
            :cpntSDocDescricao="cpntSDocPreNotas[abasVal].s_doc_descricao"
            :cpntSDocTotalServico="cpntSDocPreNotas[abasVal].s_doc_vTServico"
            :cpntSDocDeducaoBC="cpntSDocPreNotas[abasVal].s_doc_deducao_bc"
            :cpntSDocDesconto="cpntSDocPreNotas[abasVal].s_doc_desconto"
            :cpntSDocBaseCalculo="cpntSDocPreNotas[abasVal].s_doc_bc"
            :cpntSDocIssAliquota="cpntSDocPreNotas[abasVal].s_doc_iss_a"
            :cpntSDocFlagReterIss="cpntSDocPreNotas[abasVal].s_doc_iss_flag_r"
            :cpntSDocValorLiquido="cpntSDocPreNotas[abasVal].s_doc_vTLiquido"
            :cpntSDocPisAliquota="cpntSDocPreNotas[abasVal].s_doc_r_pis_a"
            :cpntSDocPisValor="cpntSDocPreNotas[abasVal].s_doc_r_pis_v"
            :cpntSDocCofinsAliquota="cpntSDocPreNotas[abasVal].s_doc_r_cofins_a"
            :cpntSDocCofinsValor="cpntSDocPreNotas[abasVal].s_doc_r_cofins_v"
            :cpntSDocCsllAliquota="cpntSDocPreNotas[abasVal].s_doc_r_csll_a"
            :cpntSDocCsllValor="cpntSDocPreNotas[abasVal].s_doc_r_csll_v"
            :cpntSDocIrrfAliquota="cpntSDocPreNotas[abasVal].s_doc_r_irrf_a"
            :cpntSDocIrrfValor="cpntSDocPreNotas[abasVal].s_doc_r_irrf_v"
            :cpntSDocInssAliquota="cpntSDocPreNotas[abasVal].s_doc_r_inss_a"
            :cpntSDocInssValor="cpntSDocPreNotas[abasVal].s_doc_r_inss_v"
            :cpntSDocOutrasRetencoesValor="cpntSDocPreNotas[abasVal].s_doc_r_outros_v"
            ref='conteudo'
            ></Demanda-Editar-Servicos-Documento-Conteudo>
          </div>

          <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
            <div class="acoes" v-if="cpntSDocAcoes[abasVal].danfe !== '0' && [ '', null, undefined ].indexOf(cpntSDocAcoes[abasVal]) === -1">
              <!-- SETA A TABELA DO DANFE -->
              <table class="danfe">
                <tr>
                  <td colspan="3">
                    <div>
                      <!-- RADIO ABRIR -->
                      <div>
                        <input :id='"dem-edi-ser-doc--abrir"' type="radio" class="app-checkbox" v-model="danfeAcao" :value="'abrir'">
                        <label :for='"dem-edi-ser-doc--abrir"' v-html="'Abrir'"></label>
                      </div>

                      <!-- RADIO IMPRIMIR -->
                      <div>
                        <input :id='"dem-edi-ser-doc--imprimir"' type="radio" class="app-checkbox" v-model="danfeAcao" :value="'imprimir'">
                        <label :for='"dem-edi-ser-doc--imprimir"' v-html="'Imprimir'"></label>
                      </div>

                      <!-- BOTÃO REENVIAR -->
                      <div>
                        <App-Button @onClick="demEdiSerDocOnReenviarNota">
                          Reenviar Cliente
                        </App-Button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="danfe">
                    <div>
                      <div>
                        <App-Button :cpntStatus="botoes.danfe" :cpntClass="'btn btn-default'" @onClick="() => { demEdiSerDocOnAbrirDocumentoFiscal(cpntSDocPreNotas[abasVal].s_doc_docs) }">
                            <!-- SETA O ICONE A SER UTILIZADO -->
                          <App-Icone :cpntTipo="'danfe-icon'"></App-Icone>
                          <br/>
                          DANFE
                        </App-Button>
                      </div>
                    </div>
                  </td>
                  <td class="xml">
                    <div>
                      <div>
                        <App-Button :cpntStatus="botoes.xml" :cpntClass="'btn btn-default'" @onClick="() => { demEdiSerDocOnAbrirDocumentoFiscal(cpntSDocPreNotas[abasVal].s_doc_docs, 'xml') }">
                          <!-- SETA O ICONE A SER UTILIZADO -->
                          <App-Icone :cpntTipo="'xml-icon'"></App-Icone>
                          <br/>
                          XML
                        </App-Button>
                      </div>
                    </div>
                  </td>
                  <td class="cancelar">
                    <div>
                      <div>
                        <App-Button :cpntClass="'btn btn-default'" @onClick="demEdiSerDocCancelamento()" v-if="cpntSDocAcoes[abasVal].cancelar === '1'">
                          <!-- SETA O ICONE A SER UTILIZADO -->
                          <App-Icone :cpntTipo="'alerta'"></App-Icone>
                          <br/>
                          Cancelar
                        </App-Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            
            <div class="botoes" v-if="cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].salvar === '1' || cpntSDocAcoes[abasVal].consultar === '1'">
              <!-- SETA O BOTÃO SALVAR E EMITIR -->
              <div class="iniciais">
                <!-- BOTÃO SALVAR -->
                <App-Button v-if="cpntSDocAcoes[abasVal].salvar === '1'" :cpntStatus="botoes.salvar" :cpntClass='[ "btn", "btn-default" ]' @onClick='() => { demEdiSerDocSalvarAlteracoes() }' :cpntTabIndex="17032060">
                  <!-- SETA O ICONE A SER UTILIZADO -->
                  <App-Icone :cpntTipo="'salvar'"></App-Icone>

                  <!-- SETA A QUEBRA DE LINHA -->
                  <br/>

                  <!-- SETA O TEXTO DO BOTÃO -->
                  <span>Salvar</span>
                </App-Button>

                <!-- BOTÃO EMITIR -->
                <App-Button v-if="(cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].emitir === '2' || cpntSDocAcoes[abasVal].reemitir === '1' || cpntSDocAcoes[abasVal].consultar === '1')" :cpntStatus="botoes.emitir" :cpntClass='[ "btn", "btn-default" ]' @onClick='() => { demEdiSerDocRealizarEmissao() }' :cpntTabIndex="17032061">
                  <template v-if="cpntSDocAcoes[abasVal].emitir === '1'">
                    <!-- SETA O ICONE A SER UTILIZADO -->
                    <App-Icone :cpntTipo="'emitir'"></App-Icone>

                    <!-- SETA A QUEBRA DE LINHA -->
                    <br/>

                    <!-- SETA O TEXTO DO BOTÃO -->
                    <span>Emitir</span>

                    <!-- VERIFICA SE A EMISSÃO ESTÁ PENDENTE -->
                    <span v-if="cpntSDocAcoes[abasVal].emitir === '2'"><b style="color: red; font-size: var(--font-base-soma-11);"><br/>[Pendente]</b></span>
                  </template>
                  <template v-else-if="cpntSDocAcoes[abasVal].reemitir === '1'">
                    <!-- SETA O ICONE A SER UTILIZADO -->
                    <App-Icone :cpntTipo="'reemitir'"></App-Icone>

                    <!-- SETA A QUEBRA DE LINHA -->
                    <br/>

                    <!-- SETA O TEXTO DO BOTÃO -->
                    <span>Reemitir</span>
                  </template>
                  <template v-else-if="cpntSDocAcoes[abasVal].consultar === '1'">
                    <span>Consultar<br/>Situações</span>
                  </template>
                </App-Button>
              </div>
            </div>

            <!-- SETA OS BOTOES DE LOG DE COMUNICAÇÃO -->
            <div class="logs" v-if="(cpntSDocAcoes[abasVal].reemitir === '1' || cpntSDocAcoes[abasVal].consultar === '1' || cpntSDocAcoes[abasVal].log === '1') === true">
              <table>
                <tr>
                  <td>
                    <DF-Log
                    :cpntDfId="Number(cpntSDocPreNotas[abasVal].s_doc_docs)"
                    :cpntDfLogTipo="'comunicacao'"
                    :cpntDados="cpntSDocPreNotas[abasVal]"
                    :cpntMostrarBT="true"
                    :cpntMostrarTab="false"
                    ref='log_comunicacao'
                    ></DF-Log>
                  </td>
                  <td v-if="!(cpntSDocAcoes[abasVal].emitir === '1' || cpntSDocAcoes[abasVal].salvar === '1' || cpntSDocAcoes[abasVal].consultar === '1')">
                    <DF-Log
                    :cpntDfId="Number(cpntSDocPreNotas[abasVal].s_doc_docs)"
                    :cpntDfLogTipo="'email'"
                    :cpntDados="cpntSDocPreNotas[abasVal]"
                    :cpntMostrarBT="true"
                    :cpntMostrarTab="false"
                    ref='log_email'
                    ></DF-Log>
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </template>
      </template>
    </template>

    <!-- ABRE A TELA DE AVISO -->
    <RF-Dialog v-if="confirmacao === true"
    :cpntStatus='""'
    :cpntLargura='"545px"'
    :cpntTitulo="'Aviso importante'"
    :cpntOnFecharDialog='() => { demEdiSerDocConfirmaAlteracaoDoc(false) }'>
    <template slot='conteudo'>
      <div class="dem-edi-ser-doc--s_doc_tp-confirm">
        Este procedimento irá limpar todos os dados do documento digitado.
        <br><br>
        Deseja prosseguir?
        <br><br>
        <App-Button @onClick="() => { demEdiSerDocConfirmaAlteracaoDoc(true) }">Sim</App-Button>
        <App-Button @onClick="() => { demEdiSerDocConfirmaAlteracaoDoc(false) }">Não</App-Button>
      </div>
    </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
.dem-edi-ser-doc {
  vertical-align: top;
  width: 370px;
  max-width: 370px;
  min-width: 370px;
  border-radius: 6px;
  border-collapse: collapse;
  border-style: hidden;
  box-shadow: 0 0 0 1px #c6c4c4;
  background-color: #fff;
}
.dem-edi-ser-doc > .documento {
  padding: 23px 10px 15px 10px;
  background: #f1f1f1;
  border-bottom: 1px solid #c6c4c4;
}
  .dem-edi-ser-doc > .documento > div {
    width: 100%;
  }
  .dem-edi-ser-doc > .com-botao > div {
    width: calc(100% - 115px - 10px);
    margin-right: 10px;
  }
  .dem-edi-ser-doc > .com-botao > button {
    width: 115px;
  }

.dem-edi-ser-doc > .abas {
  margin-top: -10px;
  background: #f1f1f1;
}

.dem-edi-ser-doc > .acoes ~ .botoes {
  margin-bottom: -10px !important;
}
.dem-edi-ser-doc > .botoes > .iniciais {
  padding-top: 5px;
  padding-bottom: 10px;
  text-align: center;
}
  .dem-edi-ser-doc > .botoes > .iniciais > button {
    padding: 8px 10px;
    min-width: 75px;
    min-height: 68px;
  }
  .dem-edi-ser-doc > .botoes > .iniciais > button:first-child {
    margin-right: 30px;
  }
  .dem-edi-ser-doc > .botoes > .iniciais > button:last-child {
    margin-left: 30px;
  }

  .dem-edi-ser-doc > .logs {
    width: 100%;
    border-top: 1px solid #ccc;
    margin-top: 10px;
  }
    .dem-edi-ser-doc > .logs > table,
    .dem-edi-ser-doc > .logs > table > tr {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
      .dem-edi-ser-doc > .logs > table > tr > td {
        width: 50%;
        min-width: 50%;
        max-width: 50%;
        padding: 5px;
        vertical-align: top;
      }

  .dem-edi-ser-doc > .acoes {
    padding: 10px;
    margin-top: -10px !important;
    margin-bottom: -10px !important;
    /* padding-top: 10px !important;
    margin-bottom: -10px !important; */
  }
    .dem-edi-ser-doc > .acoes > table.danfe {
      width: 100%;
    }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:first-child > td > div > div {
        display: inline-block;
        width: calc(100% / 3);
      }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:first-child > td > div > div:last-child {
        text-align: right;
      }

      .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td.danfe {
        width: 100px;
        text-align: center;
      }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td:not(.danfe) {
        width: calc(250px / 2);
        text-align: center;
      }

      .dem-edi-ser-doc > .acoes > table.danfe > tr:first-child > td > div,
      .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td.danfe > div {
        background-color: #e5e5e5;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
        padding: 6px;
      }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:first-child > td > div {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-radius: 6px 6px 6px 0;
      }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td.danfe > div {
        border-bottom: 1px solid #ccc;
        border-radius: 0 0 6px 6px;
      }
      .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td > div {
        padding: 6px;
        margin-top: -1px;
      }
          .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td > div > div.com-cce > button {
            margin: 2px 0px;
            padding: 4px 6px;
          }
        .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td > div > div:not(.com-cce) > button {
          height: 64px;
          min-height: 64px;
          padding: 8px 10px;
        }
        .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td > div > div > button {
          width: 75px;
          min-width: 75px;
        }
        .dem-edi-ser-doc > .acoes > table.danfe > tr:last-child > td.danfe > div > div > button {
          width: 100%;
          min-width: 100%;
        }

  .dem-edi-doc-df {
    padding: 10px;
    /* margin-top: -10px !important; */
    margin-bottom: -15px !important;
    /* margin-top: -10px;
    margin-bottom: -5px; */
  }
    .dem-edi-doc-df > div {
      margin-bottom: 8px;
    }
    .dem-edi-doc-df > div > div {
      width: 130px;
      display: inline-block;
    }
      .dem-edi-doc-df > div > button {
        width: 140px;
        padding: 4px 0px;
      }

  .sem-pre-nota {
    padding: 40px 10px 40px 10px;
    text-align: center;
  }
  .sem-pre-nota > div {
    margin-bottom: 20px;
  }

  .dem-edi-ser-doc--s_doc_tp-confirm {
    text-align: center;
  }
    .dem-edi-ser-doc--s_doc_tp-confirm > button {
      margin-right: 15px;
      min-width: 60px;
    }
</style>

<style>
.sem-pre-nota > div > span > img {
  width: 40px !important;
  height: 40px !important;
}
.dem-edi-ser-doc > .botoes > .iniciais > button > span > span > svg {
  font-size: 18px;
  margin-bottom: 4px;
}
.dem-edi-ser-doc > .abas > div > div > div > .nav-tabs {
  padding-left: 10px;
  border-bottom: 1px solid #c6c4c4;
}
  .dem-edi-ser-doc > .abas > div > div > div > .nav-tabs .nav-item.show .nav-link, 
  .dem-edi-ser-doc > .abas > div > div > div > .nav-tabs .nav-link.active {
    color: #495057 !important;
    background-color: #fff !important;
    border-color: #c6c4c4 #c6c4c4 #fff !important;
  }

.dem-edi-ser-doc > .com-botao > button > span > span > svg {
  font-size: 18px;
}
</style>

<script>
  export default {
    props: {
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntDemStatus: {
        required: true
      },
      cpntFinStatus: {
        required: true
      },

      cpntIdConPessoa: {
        required: true
      },
      cpntSDocNFEmitida: {
        required: true
      },
      cpntSDocTp: {
        required: true
      },
      cpntSDocTpOptions: {
        required: true
      },
      cpntSDocAcoes: {
        required: true
      },
      cpntSDocPreNotas: {
        required: true
      },

      cpntSDocManualCodVerificacao: {
        required: true
      },
      cpntSDocManualDesconto: {
        required: true
      },
      cpntSDocManualDataEmissao: {
        required: true
      },
      cpntSDocManualNumero: {
        required: true
      },
      cpntSDocManualSerie: {
        required: true
      },
      cpntSDocManualRetencao: {
        required: true
      },
      
      // cpntIdConCnpjCpf: {
      //   required: true
      // },
      // cpntSDocDocs: {
      //   required: true
      // },
      // cpntSDocCCe: {
      //   required: true
      // },
      // cpntSDocFiscal: {
      //   required: true
      // },
      // cpntSDocOpe: {
      //   required: true
      // },
      // cpntSDocNatOpe: {
      //   required: true
      // },
      // cpntSDocFin: {
      //   required: true
      // },
      // cpntSDocRefChave: {
      //   required: true
      // },
      // cpntSDocIndPres: {
      //   required: true
      // },
      // cpntSDocFreTp: {
      //   required: true
      // },
      // cpntSDocFrePlacaUf: {
      //   required: true
      // },
      // cpntSDocFrePlaca: {
      //   required: true
      // },
      // cpntSDocFreVolumes: {
      //   required: true
      // },
      // cpntSDocRetPrevA: {
      //   required: true
      // },
      // cpntSDocDataHoraSaiEnt: {
      //   required: true
      // },
      // cpntSDocTransportadora: {
      //   required: true
      // },
      // cpntSDocManualDes: {
      //   required: true
      // },
      // cpntSDocAcoes: {
      //   required: true
      // }
    },
    components: {
      'Demanda-Editar-Servicos-Documento-Conteudo': () => import('@/components/demanda/Editar/Servico/Demanda-Editar-Servicos-Documento-Conteudo.vue'),
      'DF-Log': () => import('@/components/_geral/DF-Log.vue'),
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        confirmacao: false,
        campos: {
        s_doc_tp: {
            id: 'dem-edi-ser-doc--s_doc_tp',
            status: '',
            tabIndex: 17031001,
            nome: 'Documento',
            keyValue: 'id',
            keyMostra: [ 'desc' ],
            options: [],
            apiEnv: 's_doc_tp',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: 'Selecione',
            value: '',
            onChange: this.demEdiSerDocOnChangeValue
          }
        },
        abasVet: {},
        abasVal: '',
        danfeAcao: 'imprimir',
        mostrarDetalhes: false,
        botoes: {
          salvar: '',
          cancelar: '',
          reinicializar: '',
          emitir: '',
          danfe: '',
          cce: '',
          xml: ''
        }
      }
    },
    mounted: function () {
      this.demEdiSerDocIniciar()
    },
    methods: {
      demEdiSerDocIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiSerDocSetarStatusGeral('carregando')

        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEdiSerDocSetarValorCampo(chave)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // CHAMA A FUNÇÃO PARA SETAR AS ABAS
        this.demEdiSerDocSetarAbas()

        // SETA O STATUS DA TELA
        this.demEdiSerDocSetarStatusGeral('')
      },
      demEdiSerDocSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocSetarValorCampo: function (chave) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 's_doc_tp':
            value = this.cpntSDocTp
            options = this.cpntSDocTpOptions
            break
        }

        // QUEBRA A LIGAÇÃO DO VUE
        value = JSON.parse(JSON.stringify(value))

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 's_doc_tp':
            // PEGA O VALOR SELECIONADO
            var _value = typeof value === 'string' ? value : value.id

            // VERIFICA SE DEVE ALTERAR O DOCUMENTO
            if (_value !== this.cpntSDocTp) {
              if ([ 'NFSe' ].indexOf(this.cpntSDocTp) !== -1 && [ '', null, undefined ].indexOf(this.cpntSDocPreNotas) === -1 && Object.keys(this.cpntSDocPreNotas).length >= 1) {
                this.demEdiSerDocConfirmaAlteracaoDoc(false)
              } else {
                this.demEdiSerDocAlterarDocumento()
              }
            }
            break
        }
      },
      demEdiSerDocAlterarDocumento: function () {
        // PEGA OS VALORES PARA COMPARAÇÃO
        var value = typeof this.campos.s_doc_tp.value === 'string' ? this.campos.s_doc_tp.value : this.campos.s_doc_tp.value.id
        var valueIni = typeof this.campos.s_doc_tp.valueIni === 'string' ? this.campos.s_doc_tp.valueIni : this.campos.s_doc_tp.valueIni.id

        // VERIFICA SE DEVE ATUALIZAR O DOCUMENTO OU NÃO
        if (value !== valueIni) {
          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
          const finalizacao = () => {
            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES')

            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }

          // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { s_doc_tp: this.campos.s_doc_tp.value }

          // CONVERTE O VALOR RECEBIDO
          if (typeof formData.s_doc_tp === 'object') {
            formData.s_doc_tp = formData.s_doc_tp.id
          }

          // SETA O ID DA DEMANDA QUE DEVE ALTERAR
          formData.cod_venda = this.cpntDemandaId

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/venda', 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiSerDocTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // MANDA ATUALIZAR AS INFORMAÇÕES DO MENU
              this.$store.commit('SET_INFO_MENU')

              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar = ''
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              finalizacao()
            }
          }, (apiError) => {
            // SETA O ERRO RECEBIDO
            this.demEdiSerDocSetarStatusGeral(apiError)

            // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
            finalizacao()
          }, (apiValid, apiStatus) => { this.demEdiSerDocTratarValidacao(apiValid, apiStatus, finalizacao) })
        }
      },
      demEdiSerDocErroAtualizacaoContato: function (mensagem = '') {
        // APRESETAN A MENSAGEM QUE A INFORMAÇÃO FOI GERADA
        if ([ '', null, undefined ].indexOf(mensagem) === -1) {
          this.$store.state.msgWarn(mensagem, 'danger')
        }

        // SETA O STATUS DE CARREGANDO DO BOTÃO
        this.botoes.salvar = ''
        this.botoes.emitir = ''

        // TRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
      },
      demEdiSerDocTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar = ''

          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demEdiSerDocRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiSerDocRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiSerDocSetarAbas: function () {
        // INICIA A VARIAVEL DE ABAS
        var abas = {}

        // RODA AS ABAS MONTANDO OS TITULOS
        for (var index in this.cpntSDocPreNotas) {
          abas[index] = {
            chave: index,
            nome: this.cpntSDocPreNotas[index].index + ' - NFS-e',
            alertas:  { qtde: 0, mensagem: '' },
            erros:    { qtde: 0, mensagem: '' }
          }

          // VERIFICA SE DEVE APRESENTAR MENSAGEM NA ABA
          if (this.cpntSDocAcoes[index].reemitir === '1') {
            abas[index].erros = { qtde: 1, mensagem: 'Nota Fiscal rejeitada' }
          } else if (this.cpntSDocAcoes[index].consultar === '1') {
            abas[index].alertas = { qtde: 1, mensagem: 'Nota Fiscal pendente ou falha de conexão' }
          } else if (this.cpntSDocAcoes[index].danfe === '1') {
            abas[index].success = { qtde: 1, mensagem: 'Nota Fiscal emitida' }
          }
        }

        // SETA AS ABAS MONTADAS
        this.abasVet = abas

        // SETA A ABA INICAL
        if (Object.keys(this.abasVet).length >= 1 && ([ '', null, undefined ].indexOf(this.abasVal) !== -1 || [ '', null, undefined ].indexOf(this.abasVet[this.abasVal]) !== -1)) {
          this.demEdiSerDocOnChangeAba(Object.keys(abas)[0])
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocOnChangeAba: function (aba) {
        // SETA A ABA SELECIONADA
        this.abasVal = aba

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiSerDocSalvarAlteracoes: function (callback = null) {
        if (callback !== null && this.cpntSDocTp === 'NFSe' && (this.cpntFinStatus === 's' || ([ '', null, undefined ].indexOf(this.cpntSDocAcoes[this.abasVal]) === -1 && this.cpntSDocAcoes[this.abasVal].salvar !== '1'))) {
          callback()
        } else {

          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar = 'carregando'
  
          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)
  
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.$refs.conteudo.campos, { disabled: false }).then((formData) => {
            // SETA SE DEVE RETER O ISS => 1 - COM RETENÇÃO || 2 - SEM RETENÇÃO
            if ([ '', null, undefined ].indexOf(formData.iss_flag_r) === -1) {
              formData.iss_flag_r = [ true, 'true', '1', 1 ].indexOf(formData.iss_flag_r) !== -1 ? '1' : '2'
            }
  
            // VERIFICA SE TEM ALGUMA CAMPO PARA ATUALIZAR
            if (Object.keys(formData).length === 0) {
              // APRESENTA A MENSAGEM
              if (callback === null) {
                this.$store.state.msgWarn('WEB [406]: ' + 'Nenhum alteração foi realizada.', 'warning')
              }
  
              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar = ''
  
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
  
              // EXECUTA O CALLBACK RECEBIDO
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            } else {
              // INICIA A ROTA QUE DEVE CHAMAR
              var router = ''
  
              // VERIFICA O CAMPO QUE DEVE ENVIAR
              if (this.cpntSDocTp === 'NFSe') {
                // 0 = Apenas os campos manuais serão atualizados.
                // 1 = A api verifique se o prestador ou tomador alterou de Regime Normal para Simples Nacional ou vice-versa (PS: Caso mude para o SN todas as retenções serão zeradas (inclusive valores minimos base, Caso mude para Regime Normal as retenções permanecerão zeradas permitindo mudar manualmente). Neste caso não informar os campos de alterações manuais (todos abaixo deste).
                // 2 = (Somente para Regime Normal) a api irá voltar as aliquotas de retenção e valores mínimos para os originais. Neste caso não informar os campos de alterações manuais (todos abaixo deste).
                formData.acao = '0'
      
                // SETA O ID QUE SERÁ ALTERADO
                formData.j_id = JSON.stringify([ this.abasVal ])
  
                // SETA A ROTA QUE DEVE CHAMAR
                router = '/venda/servico/pre-nfse'
              } else {
                // SETA A ROTA QUE DEVE CHAMAR
                router = '/venda'
              }
  
              // SETA O ID DA DEMANDA QUE DEVE ALTERAR
              formData.cod_venda = this.cpntDemandaId
  
              // CHAMA FUNÇÃO PARA COMUNICAR COM API
              this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
    
                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.demEdiSerDocTratarValidacao(retorno.message, retorno.code)
                } else {
                  // ATUALIZA OS DADOS E DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                    // EXECUTA O CALLBACK RECEBIDO
                    if (callback !== null && typeof callback === 'function') {
                      callback()
                    } else {
                      // APRESENTA A MENSAGEM DE SUCESSO
                      this.$store.state.TRATAR_RET_LOT_API(retorno)
        
                      // SETA O STATUS DE CARREGANDO DO BOTÃO
                      this.botoes.salvar = ''
        
                      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                      this.time = new Date().getTime()
  
                      // DESTRAVA A TELA
                      this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
                    }
                  })
                }
              }, this.demEdiSerDocSetarStatusGeral, this.demEdiSerDocTratarValidacao)
            }  
          }).catch(this.demEdiSerDocSetarStatusGeral)
        }
      },
      demEdiSerDocRealizarEmissao: function () {
        // SETA O STATUS DE CARREGANDO DO BOTÃO
        this.botoes.emitir = 'carregando'

        // TRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // SALVA AS ALTERAÇÕES NO DOCUMENTO
        this.demEdiSerDocSalvarAlteracoes(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.emitir = 'carregando'

          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

          // INICIA AS VARIAVEIS
          var router = ''
          var method = ''
          var formData = {}

          // VERIFICA SE DEVE REEMITIR OU EMITIR
          if (this.cpntSDocAcoes[this.abasVal].emitir === '1') {
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/emitir'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = { j_ref: JSON.stringify([ { r: this.cpntDemandaId, tp: 's', m: '10', id: this.abasVal } ]) }
          } else if (this.cpntSDocAcoes[this.abasVal].reemitir === '1') {
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/reemitir'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'PUT'

            // SETA O ID DO DOC_FISCAL
            formData = { j_df: JSON.stringify([ this.cpntSDocPreNotas[this.abasVal].s_doc_docs ]) }
          } else if (this.cpntSDocAcoes[this.abasVal].consultar === '1') {
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/consultar'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'PUT'

            // SETA O ID DO DOC_FISCAL
            formData = { j_df: JSON.stringify([ this.cpntSDocPreNotas[this.abasVal].s_doc_docs ]) }
          }

          // SETA A FUNÇÃO DE FINALIZAÇÃO
          var finalizacao = () => {
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar = ''
              this.botoes.emitir = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // REINICIA OS DADOS DA TELA
              this.demEdiSerDocIniciar()
            })
          }
          
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiSerDocTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // FINALIZA O PROCESSO
              finalizacao()
            }
          }, this.demEdiSerDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiSerDocTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      demEdiSerDocOnAbrirDocumentoFiscal: function (id, acao = '') {
        // VERIFICA AÇÃO QUE DEVE REALIZAR
        var botao = acao === '' ? 'danfe' : acao

        // SETA O STATUS PARA BOTÃO
        this.botoes[botao] = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA AÇÃO QUE DEVE REALIZAR
        acao = acao === '' ? this.danfeAcao : acao

        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'ABRIR_DOC_FISCAL', id: id, acao: acao, origem: 'df' }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          setTimeout(() => {
            // SETA O STATUS PARA BOTÃO
            this.botoes[botao] = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 1000)
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiSerDocOnReenviarNota: function () {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'REENVIAR_NOTA', id: this.cpntSDocPreNotas[this.abasVal].s_doc_docs }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demEdiSerDocAtualizarLogsTipo('log_email')
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiSerDocAtualizarLogs: function () {
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS LOG DE COMUNICAÇÃO
        this.demEdiSerDocAtualizarLogsTipo('log_comunicacao')

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS LOG DE EMAIL
        this.demEdiSerDocAtualizarLogsTipo('log_email')
      },
      demEdiSerDocAtualizarLogsTipo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiSerDocAtualizarLogsTipo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]
            
            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.dfLogsBuscarDados) === -1 && typeof elemento.dfLogsBuscarDados === 'function') {
              elemento.dfLogsBuscarDados()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiSerDocReinicializarPreNotas: function () {
        if (confirm('Automaticamente serão reiniciados todos os documento fiscais (NFS-e) desta venda de acordo com a configuração fiscal de suas categorias.\n\nDependendo dos novos cálculos poderá haver a exclusão ou inclusão de documentos fiscais.\n\nEsta operação não poderá ser desfeita. Deseja prosseguir?')) {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.reinicializar = 'carregando'

          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

          // INICIA AS VARIAVEIS
          var formData = { j_cod_venda: JSON.stringify([ this.cpntDemandaId ]) }

          // SETA A FUNÇÃO DE FINALIZAÇÃO
          var finalizacao = () => {
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.reinicializar = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // REINICIA OS DADOS DA TELA
              this.demEdiSerDocIniciar()
            })
          }
          
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/venda/servico/pre-nfse/reinicializar', 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiSerDocTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // FINALIZA O PROCESSO
              finalizacao()
            }
          }, this.demEdiSerDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiSerDocTratarValidacao(apiValid, apiStatus, finalizacao) })
        }
      },
      demEdiSerDocCancelamento: function () {
        if (confirm('Este processo irá desvincular a venda desta NFS-e. Somente será possível consultar esta NFS-e através de Docs. Fiscais -> Gerenciar.\n\nDeseja prosseguir com o cancelamento?')) {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.cancelar = 'carregando'

          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

          // INICIA AS VARIAVEIS
          var formData = { j_df: JSON.stringify([ this.cpntSDocPreNotas[this.abasVal].s_doc_docs ]) }

          // SETA A FUNÇÃO DE FINALIZAÇÃO
          var finalizacao = () => {
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.cancelar = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // REINICIA OS DADOS DA TELA
              this.demEdiSerDocIniciar()
            })
          }
          
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/df/cancelar', 'POST', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiSerDocTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // FINALIZA O PROCESSO
              finalizacao()
            }
          }, this.demEdiSerDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiSerDocTratarValidacao(apiValid, apiStatus, finalizacao) })
        }
      },
      demEdiSerDocConfirmaAlteracaoDoc: function (confirma = false) {
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS
        if (confirma === true) {
          this.demEdiSerDocAlterarDocumento()
        } else if (this.confirmacao === true) {
          this.demEdiSerDocSetarValorCampo('s_doc_tp')
        }

        // FECHA A TELA DE CONFIRMAÇÃO DE ALTERAÇÃO
        this.confirmacao = confirma === true ? false : !this.confirmacao

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TELA
        this.demEdiSerDocSetarStatusGeral('')
      }
    },
    watch: {
      cpntSDocTp: function () {
        this.demEdiSerDocIniciar()
      },
      cpntSDocTpOptions: function () {
        this.demEdiSerDocSetarValorCampo('s_doc_tp')
      },
      cpntSDocPreNotas: function () {
        this.demEdiSerDocSetarAbas()
      }
    }
  }
</script>
